/**
 * Mock data pre podpurné orgány (OVMs)
 */

import { ovmIds, countryIds, municipalityIds } from "./officials";

// Generátor dátumov
const generateDate = (yearsAgo, monthOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - yearsAgo);
  date.setMonth(date.getMonth() + monthOffset);
  return date.toISOString();
};

export const ovms = [
  {
    id: ovmIds.ministerstvo,
    ic: "00006947",
    subject: "Ministerstvo financí",
    username: "mfcr_admin",
    databox: "xzeaauv",
    officialsCount: 45,
    created: generateDate(8),
    email: "podatelna@mfcr.cz",
    phone: "+420257041111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Letenská",
      orientationNumber: "525/15",
      zip: "11800",
    },
    contactPerson: {
      firstName: "Helena",
      lastName: "Kratochvílová",
      email: "helena.kratochvilova@mfcr.cz",
      phone: "+420257042222",
    },
  },
  {
    id: ovmIds.mestoPraha,
    ic: "00064581",
    subject: "Magistrát hl. m. Prahy",
    username: "praha_admin",
    databox: "48ia97h",
    officialsCount: 128,
    created: generateDate(7),
    email: "posta@praha.eu",
    phone: "+420236001111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Mariánské náměstí",
      orientationNumber: "2/2",
      zip: "11001",
    },
    contactPerson: {
      firstName: "Jiřina",
      lastName: "Nováková",
      email: "jirina.novakova@praha.eu",
      phone: "+420236001234",
    },
  },
  {
    id: ovmIds.senat,
    ic: "63839407",
    subject: "Kancelář Senátu",
    username: "senat_admin",
    databox: "eqkab4n",
    officialsCount: 81,
    created: generateDate(10),
    email: "info@senat.cz",
    phone: "+420257071111",
    isDeputyOrSenator: true,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Valdštejnské náměstí",
      orientationNumber: "17/4",
      zip: "11801",
    },
    contactPerson: {
      firstName: "Radek",
      lastName: "Svoboda",
      email: "radek.svoboda@senat.cz",
      phone: "+420257072222",
    },
  },
  {
    id: ovmIds.snemovna,
    ic: "00006572",
    subject: "Kancelář Poslanecké sněmovny",
    username: "psp_admin",
    databox: "fs4abc8",
    officialsCount: 200,
    created: generateDate(10),
    email: "info@psp.cz",
    phone: "+420257171111",
    isDeputyOrSenator: true,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Sněmovní",
      orientationNumber: "176/4",
      zip: "11800",
    },
    contactPerson: {
      firstName: "Martina",
      lastName: "Procházková",
      email: "martina.prochazkova@psp.cz",
      phone: "+420257172222",
    },
  },
  {
    id: ovmIds.krajBrno,
    ic: "70888337",
    subject: "Jihomoravský kraj",
    username: "jmk_admin",
    databox: "x2pbqzq",
    officialsCount: 67,
    created: generateDate(6),
    email: "posta@kr-jihomoravsky.cz",
    phone: "+420541651111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Žerotínovo náměstí",
      orientationNumber: "449/3",
      zip: "60182",
    },
    contactPerson: {
      firstName: "Pavel",
      lastName: "Dvořák",
      email: "pavel.dvorak@kr-jihomoravsky.cz",
      phone: "+420541652222",
    },
  },
  {
    id: ovmIds.mestoBrno,
    ic: "44992785",
    subject: "Statutární město Brno",
    username: "brno_admin",
    databox: "a7kbrrn",
    officialsCount: 89,
    created: generateDate(7),
    email: "posta@brno.cz",
    phone: "+420542171111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Dominikánské náměstí",
      orientationNumber: "196/1",
      zip: "60167",
    },
    contactPerson: {
      firstName: "Kateřina",
      lastName: "Horáková",
      email: "katerina.horakova@brno.cz",
      phone: "+420542172222",
    },
  },
  {
    id: ovmIds.obecRoztoky,
    ic: "00241610",
    subject: "Městský úřad Roztoky",
    username: "roztoky_admin",
    databox: "pfkbuve",
    officialsCount: 12,
    created: generateDate(4),
    email: "podatelna@roztoky.cz",
    phone: "+420220400111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.roztoky, name: "Roztoky" },
      municipalityId: municipalityIds.roztoky,
      street: "Masarykova",
      orientationNumber: "1/1",
      zip: "25263",
    },
    contactPerson: {
      firstName: "Eva",
      lastName: "Černá",
      email: "eva.cerna@roztoky.cz",
      phone: "+420220400222",
    },
  },
  {
    id: ovmIds.ministerstvoPrace,
    ic: "00551023",
    subject: "Ministerstvo práce a sociálních věcí",
    username: "mpsv_admin",
    databox: "sc9aavg",
    officialsCount: 52,
    created: generateDate(8),
    email: "posta@mpsv.cz",
    phone: "+420221921111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Na Poříčním právu",
      orientationNumber: "376/1",
      zip: "12801",
    },
    contactPerson: {
      firstName: "Tomáš",
      lastName: "Krejčí",
      email: "tomas.krejci@mpsv.cz",
      phone: "+420221922222",
    },
  },
  {
    id: "ovm-009-ministerstvo-zdravotnictvi",
    ic: "00024341",
    subject: "Ministerstvo zdravotnictví",
    username: "mzcr_admin",
    databox: "pv8aaxd",
    officialsCount: 38,
    created: generateDate(7),
    email: "mzcr@mzcr.cz",
    phone: "+420224971111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Palackého náměstí",
      orientationNumber: "375/4",
      zip: "12801",
    },
    contactPerson: {
      firstName: "Lucie",
      lastName: "Benešová",
      email: "lucie.benesova@mzcr.cz",
      phone: "+420224972222",
    },
  },
  {
    id: "ovm-010-krajsky-urad-plzen",
    ic: "70890366",
    subject: "Krajský úřad Plzeňského kraje",
    username: "plzen_kraj_admin",
    databox: "zzjbqkp",
    officialsCount: 54,
    created: generateDate(5),
    email: "posta@plzensky-kraj.cz",
    phone: "+420377195111",
    isDeputyOrSenator: false,
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.plzen, name: "Plzeň" },
      municipalityId: municipalityIds.plzen,
      street: "Škroupova",
      orientationNumber: "1760/18",
      zip: "30613",
    },
    contactPerson: {
      firstName: "Martin",
      lastName: "Pokorný",
      email: "martin.pokorny@plzensky-kraj.cz",
      phone: "+420377195222",
    },
  },
];

// OVMs bez funkcionárov (pre grid OvmNoOfficialsGrid)
export const ovmsNoOfficials = ovms
  .filter((ovm) => ovm.officialsCount < 20)
  .map(({ officialsCount, ...rest }) => rest);

export default ovms;
